
const ServiceSection = () => {
  const services = [
    {
      title: "Brand Discovery",
      description: "글로벌 경쟁력 기준으로 브랜드를 선별합니다.",
      number: "01"
    },
    {
      title: "Market Entry",
      description: "글로벌 시장 기준으로 채널, 가격, 포지션을 설계합니다.",
      number: "02"
    },
    {
      title: "Localized Copywriting",
      description: "현지 소비자 언어와 규제를 고려해 리스팅을 재구성합니다.",
      number: "03"
    },
    {
      title: "Platform Marketing",
      description: "글로벌 전자상거래 환경에 맞춘 노출 전략과 검색 최적화를 실행합니다.",
      number: "04"
    },
    {
      title: "Fulfillment & CS",
      description: "주문 관리부터 배송, 고객 응대까지 운영을 책임집니다.",
      number: "05"
    }
  ];

  return (
    <section id="what-we-do" className="py-32 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-7xl md:text-8xl font-extrabold text-[#1a1a1a] mb-6 text-center leading-tight">
            What We Do
          </h2>
          
          <div className="max-w-4xl mx-auto mb-20">
            <p className="text-xl text-[#555555] font-bold tracking-tight text-left" style={{letterSpacing: '-0.02em'}}>
              Prime Connect는 브랜드를 소개하는 데서 끝나지 않습니다. 시장 안에서 작동하도록 설계하고, 직접 운영합니다.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
            {services.map((service, index) => (
              <div key={index} className="group text-center py-6 md:py-0">
                <div className="mb-6">
                  <div className="text-5xl font-semibold text-[#999999] leading-none mb-4">
                    {service.number}
                  </div>
                </div>
                
                <h3 className="text-2xl font-bold text-[#1a1a1a] mb-4 text-center">
                  {service.title}
                </h3>
                
                <p className="text-[#666666] leading-relaxed text-base">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
